import React from "react";
import { useRecoilValue } from "recoil";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import CameraType1Table from "./view/CameraType1Table";

interface CameraType1Props {}
export const CameraType1: React.FC<CameraType1Props> = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_securityconfiguration_cameratype1_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <> {userPermissions.includes(viewPermission) && <CameraType1Table />} </>
  );
};
export default CameraType1;
